export default __webpack_public_path__ + "static/media/eyeoff.43c6cc29.svg";